import React, { useState, useEffect, useRef } from "react";
import Loading from "../../../Utils/Loading/Loading";
import Filter from "./Filter/Filter";
import useSize from "../../../Utils/useSize/useSize";
import Backend from "../../..//Backend/Backend";
import moment from "moment";
import { toJpeg } from "html-to-image";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");

const backend = await new Backend().init();

export default function SettlementScreen({ user_id }) {
  const windowSize = useSize();
  const elementRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const [rent, setRentShow] = useState(0);

  const [isDollar, setIsDollar] = useState(0);

  const [uUsername, setUsername] = useState(0);

  const [broker_id, setBrokerId] = useState(0);
  const [sub_broker_id, setSubBrokerId] = useState(0);
  const [ssub_broker_id, setSsubBrokerId] = useState(0);

  const [master_sharing, setMasterSharing] = useState(0);
  const [broker_sharing, setBrokerSharing] = useState(0);
  const [subbroker_sharing, setSubBrokerSharing] = useState(0);
  const [ssubbroker_sharing, setSsubBrokerSharing] = useState(0);

  const [profitloss, setProfitLoss] = useState(0);
  const [commission, setCommission] = useState(0);

  const [master_commission, setMasterCommission] = useState(0);
  const [master_total, setMasterTotal] = useState(0);
  const [master_booked, setMasterBooked] = useState(0);
  const [master_rent, setMasterRent] = useState(0);

  const [broker_commission, setBrokerCommission] = useState(0);
  const [broker_total, setBrokerTotal] = useState(0);
  const [broker_booked, setBrokerBooked] = useState(0);
  const [broker_rent, setBrokerRent] = useState(0);

  const [sub_broker_commission, setSubBrokerCommission] = useState(0);
  const [sub_broker_total, setSubBrokerTotal] = useState(0);
  const [sub_broker_booked, setSubBrokerBooked] = useState(0);
  const [sub_broker_rent, setSubBrokerRent] = useState(0);

  const [ssub_broker_commission, setSsubBrokerCommission] = useState(0);
  const [ssub_broker_total, setSsubBrokerTotal] = useState(0);
  const [ssub_broker_booked, setSsubBrokerBooked] = useState(0);
  const [ssub_broker_rent, setSsubBrokerRent] = useState(0);

  const [date_start, setDate_Start] = useState(moment().startOf("week"));
  const [date_end, setDate_End] = useState(moment().endOf("week"));

  useEffect(() => {
    loadSettlement(moment().startOf("week"), moment().endOf("week"));
  }, []);

  const loadSettlement = (a, b) => {
    setDate_Start(a);
    setDate_End(b);
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user_id,
      start: a ? a : date_start,
      end: b ? b : date_end,
    };

    backend.settlement(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setProfitLoss(r.booked);
        setCommission(r.commission);
        setRentShow(r.nse_cash || 0);
        setIsDollar(r.isDollar || 0);

        setBrokerId(r.broker_id);
        setSubBrokerId(r.sub_broker_id);
        setSsubBrokerId(r.ssub_broker_id);

        setMasterSharing(r.mastersharing);
        setMasterCommission(r.master_commission);
        setMasterTotal(r.master_total);
        setMasterBooked(r.master_booked);
        setMasterRent(r.master_rent);

        setBrokerSharing(r.brokersharing);
        setBrokerCommission(r.broker_commission);
        setBrokerTotal(r.broker_total);
        setBrokerBooked(r.broker_booked);
        setBrokerRent(r.broker_rent);

        setSubBrokerSharing(r.subbrokersharing);
        setSubBrokerCommission(r.sub_broker_commission);
        setSubBrokerTotal(r.sub_broker_total);
        setSubBrokerBooked(r.sub_broker_booked);
        setSubBrokerRent(r.sub_broker_rent);

        setSsubBrokerSharing(r.ssubbrokersharing);
        setSsubBrokerCommission(r.ssub_broker_commission);
        setSsubBrokerTotal(r.ssub_broker_total);
        setSsubBrokerBooked(r.ssub_broker_booked);
        setSsubBrokerRent(r.ssub_broker_rent);

        setUsername(r.username);
      } else {
        if (r.logout === 1) {
          window.LogOut();
        } else {
          toast.error(r.message);
        }
      }
    });
  };

  const htmlToImageConvert = () => {
    if (!elementRef.current) return;
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "Settlement.jpeg";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => console.log(err));
  };

  const currency = isDollar === 1 ? "$" : "₹";

  const pnlMasterProfitTotal = parseFloat(
    Math.abs(master_total) + parseFloat(master_rent)
  ).toFixed(2);

  const pnlBrokerProfitTotal = parseFloat(
    Math.abs(broker_total) + parseFloat(broker_rent)
  ).toFixed(2);

  const pnlSubBrokerProfitTotal = parseFloat(
    Math.abs(sub_broker_total) + parseFloat(sub_broker_rent)
  ).toFixed(2);

  const pnlSSubBrokerProfitTotal = parseFloat(
    Math.abs(ssub_broker_total) + parseFloat(ssub_broker_rent)
  ).toFixed(2);

  const ProfitTotal = parseFloat(
    Math.abs(profitloss) +
      parseFloat(master_rent) +
      parseFloat(broker_rent) +
      parseFloat(sub_broker_rent) +
      parseFloat(ssub_broker_rent)
  ).toFixed(2);

  const totalProfitRent = parseFloat(
    parseFloat(master_rent) +
      parseFloat(broker_rent) +
      parseFloat(sub_broker_rent) +
      parseFloat(ssub_broker_rent)
  ).toFixed(2);

  const totalProfitTotal = parseFloat(
    parseFloat(profitloss) + parseFloat(commission)
  ).toFixed(2);

  const pnlMasterLossTotal = parseFloat(
    Math.abs(master_total) - parseFloat(master_rent)
  ).toFixed(2);

  const pnlBrokerLossTotal = parseFloat(
    Math.abs(broker_total) - parseFloat(broker_rent)
  ).toFixed(2);

  const pnlSubBrokerLossTotal = parseFloat(
    Math.abs(sub_broker_total) - parseFloat(sub_broker_rent)
  ).toFixed(2);

  const pnlSSubBrokerLossTotal = parseFloat(
    Math.abs(ssub_broker_total) - parseFloat(ssub_broker_rent)
  ).toFixed(2);

  const LossTotal = parseFloat(
    Math.abs(profitloss) -
      (parseFloat(master_rent) +
        parseFloat(broker_rent) +
        parseFloat(sub_broker_rent) +
        parseFloat(ssub_broker_rent))
  ).toFixed(2);

  const totalLossRent = parseFloat(
    parseFloat(master_rent) +
      parseFloat(broker_rent) +
      parseFloat(sub_broker_rent) +
      parseFloat(ssub_broker_rent)
  ).toFixed(2);

  const totalLossTotal = parseFloat(
    parseFloat(profitloss) + parseFloat(commission)
  ).toFixed(2);

  return (
    <div
      style={{
        height: windowSize[1] - 170,
        width: windowSize[0] - 100,
      }}
      className="bg-[var(--background)]"
    >
      {/* 🔹 Header */}

      <Filter settlement={loadSettlement} htmlToImageConvert={htmlToImageConvert} />

      <div
        style={{
          width: windowSize[0] - 100,
          height: windowSize[1] - 200,
        }}
        className="flex flex-col justify-center items-center"
      >
        <div
          ref={elementRef}
          style={{
            width: windowSize[0] / 2,
            height: windowSize[1] - 300,
          }}
          className="bg-[var(--background)] space-y-5 py-4 px-4 "
        >
          {/* 📋 Summary Header */}
          <div className="bg-[var(--background)] border-2 border-[var(--hover)] text-[var(--text)] rounded-xl shadow-sm text-center py-3">
            <div className="font-semibold text-[15px]">USER : {uUsername}</div>
            <div className="text-[12px] text-[var(--subtext)] mt-0.5">
              {moment(date_start).format("DD MMM YYYY")} →{" "}
              {moment(date_end).format("DD MMM YYYY")}
            </div>
          </div>

          {/* 📊 Main Data */}
          {loading ? (
            <Loading height={windowSize[1] - 400} />
          ) : (
            <div className="space-y-5">
              {/* PROFIT SECTION */}
              {profitloss < 0 ? (
                <SectionCard title="PROFIT" color="green">
                  <Table
                    currency={currency}
                    rent={rent}
                    color="green"
                    rows={[
                      {
                        user: `MASTER ${master_sharing}%`,
                        pnl: pnlMasterProfitTotal,
                        brk: parseFloat(master_commission).toFixed(2),
                        rent: parseFloat(master_rent).toFixed(2),
                        total: parseFloat(master_booked).toFixed(2),
                      },
                      broker_id > 0 && {
                        user: `BROKER ${broker_sharing}%`,
                        pnl: pnlBrokerProfitTotal,
                        brk: parseFloat(broker_commission).toFixed(2),
                        rent: parseFloat(broker_rent).toFixed(2),
                        total: parseFloat(broker_booked).toFixed(2),
                      },
                      sub_broker_id > 0
                        ? {
                            user: `SUB BROKER ${subbroker_sharing}%`,
                            pnl: pnlSubBrokerProfitTotal,
                            brk: parseFloat(sub_broker_commission).toFixed(2),
                            rent: parseFloat(sub_broker_rent).toFixed(2),
                            total: parseFloat(sub_broker_booked).toFixed(2),
                          }
                        : null,
                      ssub_broker_id > 0
                        ? {
                            user: `SSUB BROKER ${ssubbroker_sharing}%`,
                            pnl: pnlSSubBrokerProfitTotal,
                            brk: parseFloat(ssub_broker_commission).toFixed(2),
                            rent: parseFloat(ssub_broker_rent).toFixed(2),
                            total: parseFloat(ssub_broker_booked).toFixed(2),
                          }
                        : null,
                      {
                        user: "TOTAL",
                        pnl: ProfitTotal,
                        brk: parseFloat(commission).toFixed(2),
                        rent: totalProfitRent,
                        total: totalProfitTotal,
                      },
                    ].filter(Boolean)}
                  />
                </SectionCard>
              ) : (
                <SectionCard title="LOSS" color="red">
                  <Table
                    currency={currency}
                    rent={rent}
                    color="red"
                    rows={[
                      {
                        user: `MASTER ${master_sharing}%`,
                        pnl: pnlMasterLossTotal,
                        brk: parseFloat(master_commission).toFixed(2),
                        rent: parseFloat(master_rent).toFixed(2),
                        total: parseFloat(master_booked).toFixed(2),
                      },
                      broker_id > 0 && {
                        user: `BROKER ${broker_sharing}%`,
                        pnl: pnlBrokerLossTotal,
                        brk: parseFloat(broker_commission).toFixed(2),
                        rent: parseFloat(broker_rent).toFixed(2),
                        total: parseFloat(broker_booked).toFixed(2),
                      },
                      sub_broker_id > 0
                        ? {
                            user: `SUB BROKER ${subbroker_sharing}%`,
                            pnl: pnlSubBrokerLossTotal,
                            brk: parseFloat(sub_broker_commission).toFixed(2),
                            rent: parseFloat(sub_broker_rent).toFixed(2),
                            total: parseFloat(sub_broker_booked).toFixed(2),
                          }
                        : null,
                      ssub_broker_id > 0
                        ? {
                            user: `SSUB BROKER ${ssubbroker_sharing}%`,
                            pnl: pnlSSubBrokerLossTotal,
                            brk: parseFloat(ssub_broker_commission).toFixed(2),
                            rent: parseFloat(ssub_broker_rent).toFixed(2),
                            total: parseFloat(ssub_broker_booked).toFixed(2),
                          }
                        : null,
                      {
                        user: "TOTAL",
                        pnl: LossTotal,
                        brk: parseFloat(commission).toFixed(2),
                        rent: totalLossRent,
                        total: totalLossTotal,
                      },
                    ].filter(Boolean)}
                  />
                </SectionCard>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ✅ Section Wrapper
function SectionCard({ title, color, children }) {
  const colorClass =
    color === "green"
      ? "text-[var(--buymeta)]"
      : color === "red"
      ? "text-[var(--sellmeta)]"
      : "text-[var(--primary)]";

  return (
    <div className="bg-[var(--background)] border-2 border-[var(--hover)] text-[var(--text)] rounded-xl p-4 shadow-sm">
      <div className={`font-semibold text-center mb-2 ${colorClass}`}>
        {title}
      </div>
      {children}
    </div>
  );
}

// ✅ Table Component
function Table({ rows, color, currency, rent }) {
  const pnlColor =
    color === "green"
      ? "text-[var(--buymeta)]"
      : color === "red"
      ? "text-[var(--sellmeta)]"
      : "text-[var(--text)]";

  if (rows == null || !rows || rows.length === 0)
    return (
      <div className="text-center text-[12px] text-[var(--subtext)] py-2">
        No records found
      </div>
    );

  return (
    <div className="text-sm">
      {/* Header */}
      <div
        className={`grid ${
          rent > 0 ? "grid-cols-5" : "grid-cols-4"
        } text-[12px] text-[var(--subtext)] border-b border-[var(--hover)] pb-1 mb-2 font-medium`}
      >
        <span className="text-left">USER</span>
        <span className="text-right">P&L</span>
        <span className="text-right">BRK</span>
        {rent > 0 ? <span className="text-right">INT</span> : null}
        <span className="text-right">Total</span>
      </div>

      {/* Rows */}
      {rows.map((r, i) => {
        return (
          <div
            key={i}
            className={`grid ${
              rent > 0 ? "grid-cols-5" : "grid-cols-4"
            }  items-center text-[var(--text)] py-1.5 text-[13px] rounded-lg transition`}
          >
            {/* User */}
            <span className="font-medium text-left">{r.user}</span>

            {/* P&L */}
            <span
              className={`${pnlColor} font-semibold text-right text-[12px]`}
            >
              {fmt.format(Math.abs(r.total).toFixed(2))} {currency}
            </span>

            {/* BRK always red */}
            <span
              className={` ${
                r.brk > 0 ? "text-[var(--buy)]" : "text-[var(--sell)]"
              }  font-semibold text-right text-[12px]`}
            >
              {fmt.format(Math.abs(r.brk).toFixed(2))} {currency}
            </span>

            {rent > 0 ? (
              <span className="text-[var(--buy)] font-semibold text-right text-[12px]">
                {fmt.format(Math.abs(r.rent).toFixed(2))} {currency}
              </span>
            ) : null}

            {/* TOTAL = pnl + brk */}
            <span
              className={`${pnlColor} font-semibold text-right text-[12px]`}
            >
              {fmt.format(Math.abs(r.pnl))} {currency}
            </span>
          </div>
        );
      })}
    </div>
  );
}
